export default "__VITE_ASSET__DGlvxs6y__"